/** @format */

import React, { useState } from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ListedLeadsForm } from '../components/ListedLeadsForm';

interface ListedLeadsFormContainerProps {
  onSuccess?: () => void;
}

/**
 * Container for ListedLeadsForm
 * Manages modal visibility and form submission
 */
export const ListedLeadsFormContainer: React.FC<ListedLeadsFormContainerProps> = ({ onSuccess }) => {
  const [visible, setVisible] = useState(false);

  const handleOpen = () => {
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  const handleSuccess = () => {
    onSuccess?.();
    handleClose();
  };

  return (
    <>
      <Button type='primary' icon={<PlusOutlined />} onClick={handleOpen}>
        Add Listed Lead
      </Button>
      <ListedLeadsForm visible={visible} onCancel={handleClose} onSuccess={handleSuccess} />
    </>
  );
};

export default ListedLeadsFormContainer;
